import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Check, CreditCard, FileText } from 'lucide-react';
import InvoiceDetails, { validInvoiceDetails } from './InvoiceDetails';
import { BillingStatus } from './billingUi';
import './PlanUpgradeModal.css';
import './PaymentMethodModal.css';

// One entry point for how the company pays. Card continues at Stripe; invoice
// is confirmed here with the billing details. A single available method skips the choice.
export default function PaymentMethodModal({ show, choices, current, ready, inTrial, days, details, onChange, busy, error, onCancel, onConfirm }) {
    const key = choices.join(',');
    const [method, setMethod] = useState('');
    useEffect(() => {
        if (!show) return;
        const available = key ? key.split(',') : [];
        setMethod(!ready ? (available.includes('card') ? 'card' : available[0] || '') : available.find(choice => choice !== current) || available[0] || '');
    }, [show, key, ready, current]);
    const single = choices.length === 1;
    const title = single && choices[0] === 'invoice' ? 'Betala med faktura' : ready ? 'Ändra betalsätt' : 'Lägg till betalsätt';
    const invoice = method === 'invoice';
    return <Modal show={show} onHide={busy ? () => {} : onCancel} centered scrollable dialogClassName="subscription-plan-modal"
        backdrop={busy ? 'static' : true} keyboard={!busy} aria-labelledby="payment-method-title">
        <form onSubmit={event => { event.preventDefault(); if (method) onConfirm(method); }}>
            <Modal.Header closeButton={!busy}><Modal.Title as="h2" id="payment-method-title">{title}</Modal.Title></Modal.Header>
            <Modal.Body>
                {error && <BillingStatus tone="danger" title="Betalsättet kunde inte ändras" text={error} />}
                {!single && <fieldset className="payment-method-choice" disabled={busy}>
                    <legend>Välj hur företaget betalar prenumerationen.</legend>
                    {choices.map(choice => <label key={choice} className={`payment-method-option${method === choice ? ' is-selected' : ''}`}>
                        <input type="radio" name="payment-method" value={choice} checked={method === choice} onChange={() => setMethod(choice)} />
                        <span className="payment-method-option-icon" aria-hidden="true">{choice === 'card' ? <CreditCard size={18} /> : <FileText size={18} />}</span>
                        <span className="payment-method-option-text">
                            <span className="payment-method-option-title">{choice === 'card' ? 'Kort' : 'Faktura'}{ready && current === choice && <em>Nuvarande</em>}</span>
                            <span className="payment-method-option-hint">{choice === 'card' ? 'Debiteras automatiskt vid varje förnyelse. Kortet läggs till hos Stripe.' : `Faktura i SEK via e-post. ${days} dagars betalningsvillkor.`}</span>
                        </span>
                    </label>)}
                </fieldset>}
                {invoice && <div className="subscription-plan-review payment-method-form"><InvoiceDetails value={details} onChange={onChange} disabled={busy} days={days} /></div>}
                {method && <div className="subscription-plan-review-timing"><Check size={18} aria-hidden="true" />
                    <p>{invoice
                        ? (inTrial ? 'Ingen betalning idag. Den första fakturan skapas när provperioden slutar.' : 'Betalsättet gäller nya fakturor. Redan utfärdade fakturor behåller sina villkor.')
                        : `Du lägger till kortet hos Stripe och kommer sedan tillbaka hit.${inTrial ? ' Ingen debitering förrän provperioden är slut.' : ''}`}</p>
                </div>}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="subscription-plan-modal-secondary" disabled={busy} onClick={onCancel}>Avbryt</button>
                <button type="submit" className="subscription-plan-button" disabled={busy || !method || (invoice && !validInvoiceDetails(details))}>
                    {busy ? 'Bekräftar…' : invoice ? 'Bekräfta fakturabetalning' : 'Fortsätt till Stripe'}</button>
            </Modal.Footer>
        </form>
    </Modal>;
}
